'use es6';

import ActionTypes from './ActionTypes';

export function postNotification(notification) {
  return {
    type: ActionTypes.ADD_NOTIFICATION,
    payload: notification,
  };
}

export function removeNotification(id) {
  return {
    type: ActionTypes.REMOVE_NOTIFICATION,
    payload: {
      id,
    },
  };
}

export function removeAllNotifications() {
  return {
    type: ActionTypes.REMOVE_ALL_NOTIFICATIONS,
    payload: {},
  };
}
